<template>
    <div>
        <div class="d-flex align-items-center" style="justify-content: space-between !important;">
            <div class="dropdown px-2">
                <a class=" no-underline" href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <div class="d-flex justify-content-between">
                        <div>
                            <span v-if="activeTab == 'work_shift'" class="highlighted fw-500 fs-16">Work Shift</span>
                            <span v-if="activeTab == 'employee_list'" class="highlighted fw-500 fs-16">Employee
                                List</span>
                        </div>
                        <div>
                            <i class="icon-chevron-down ml-10 org-icon-rotate-transition org-icon-down fs-18"
                                style="color: #113b72; border: solid 0.5px #113b72; border-radius: 4px;"></i>
                        </div>
                    </div>
                </a>
                <div class="dropdown-menu pointer" aria-labelledby="dropdownMenuLink"
                    style="width: 215px !important;border-radius: 8px !important;left: -40px !important;margin-left: -2px !important;">
                    <a class="dropdown-item fw-500" :class="{'new-blue': activeTab == 'work_shift'}"
                        v-on:click="switchTab('work_shift')">Work Shift List</a>
                    <a class="dropdown-item fw-500" :class="{'new-blue': activeTab == 'employee_list'}"
                        v-on:click="switchTab('employee_list')">Employee List</a>
                </div>
            </div>
            <div v-if="activeTab === 'employee_list'">
                <button class="btn btn-create btn-smm"
                    @click="createEmployee">
                    <i class="icon icon-plus-circle create-icon text-white fs-20"
                        ></i>
                    <span class="ml-1  fs-14" style="color: #388e3c;"> New </span>
                </button>
            </div>
            <div v-if="activeTab === 'work_shift'">
                <button class="btn btn-create btn-smm" 
                    @click="createWorkShift">
                    <i class="icon icon-plus-circle create-icon  fs-20"></i>
                    <span class="ml-1  fs-14" style="color:#388e3c;"> New </span>
                </button>
            </div>
        </div>
        <div class="d-flex align-items-center justify-content-center" v-if="ajaxCallInProgress">
            <img src="/static/images/new-theme2024/20 card.gif" width="100" alt="">
        </div>
        <div class="content mt-3" v-else>
            <div v-if="employee_list_active">
                <div>
                    <configure-shift-employee-list-view :passed_list_data="list_data"
                        :ajaxCallInProgress="ajaxCallInProgress" :getSkipCount="getSkipCount" :limit="limit"
                        :skip="skip" :total="total" :skip_temp="skip_temp" :temp_total="temp_total"
                        @firstPage="firstPage" @lastPage="lastPage" @previousPage="previousPage" @nextPage="nextPage"
                        @emp_data_length="empDataLength" @fetchListData="fetchListData"
                        @createEmpSuccess="createEmpSuccess"></configure-shift-employee-list-view>

                </div>
            </div>
            <div v-if="work_shift_active">
                <configure-shift-work-list-view @work_data_length="workDataLength"
                    :ajaxCallInProgress="ajaxCallInProgress"></configure-shift-work-list-view>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import {
        EventBus
    } from '../../eventBus/nav-bar-event';
    import facility_mgmt from '../../mixins/facility_mgmt';
    const ConfigureShiftEmployeeListView = () => import('./ConfigureShiftEmployeeListView');
    const ConfigureShiftWorkListView = () => import('./ConfigureShiftWorkListView');
    import {
        SweetModal
    } from 'sweet-modal-vue';
    export default {
        mixins: [facility_mgmt],
        components: {
            ConfigureShiftEmployeeListView,
            ConfigureShiftWorkListView,
            SweetModal
        },
        data() {
            return {
                employee_list_active: false,
                work_shift_active: true,
                work_data_length: 0,
                list_data: [],
                ajaxCallInProgress: false,
                skip: 0,
                limit: 10,
                total: 0,
                temp_total: 0,
                search_key: '',
                pageLimit: [],
                skip_temp: 0,
                count: 0,
                pageLimit: [],
                activeTab: 'work_shift'
            }
        },
        methods: {
            switchTab(tab) {
                this.activeTab = tab;
                if (tab == 'employee_list') {
                    this.employee_list_active = true
                    this.work_shift_active = false
                    this.fetchListData();
                } else if (tab == 'work_shift') {
                    this.employee_list_active = false
                    this.work_shift_active = true
                    this.fetchListData();
                }
            },
            createEmpSuccess() {
                this.fetchListData();
            },
            createEmployee() {
                EventBus.$emit('addEmployee');
                EventBus.$emit('ZindexChangeStart')
            },
            createWorkShift() {
                EventBus.$emit('addWorkShift');
            },
            empDataLength(data) {
                this.emp_data_length = data;
            },
            workDataLength(data) {
                this.work_data_length = data;
            },
            async fetchListData() {
                this.ajaxCallInProgress = true;
                this.list_data = [];
                try {
                    let params = {
                        skip: this.skip,
                        limit: this.limit,
                        search_key: this.search_key.trim(),
                    };
                    let response = await this.getEmployeeShiftList(params);
                    this.list_data = response.response.employee_shifts
                    this.total = response.response.count;
                    this.ajaxCallInProgress = false;
                } catch (error) {
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                }
            },
            firstPage() {
                this.temp_total = 0
                this.skip = 0
                this.limit = 10
                this.list_data = []
                this.fetchListData()
            },
            lastPage() {
                this.skip_temp = 0
                this.skip = 0
                this.temp_total = this.total
                let no_of_pages = Math.ceil(this.total / this.limit)
                this.skip_temp = (no_of_pages * this.limit) - this.limit
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp
                this.fetchListData();
            },
            nextPage() {
                this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
                if (this.skip_temp >= this.total) {
                    return;
                }
                this.skip = this.skip_temp;
                this.fetchListData();
            },
            previousPage() {
                this.skip_temp = 0
                this.temp_total = 0
                if (this.skip == 0) {
                    return;
                }
                this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
                this.fetchListData();
            },
        },
        mounted() {
            for (let i = 10; i <= 50; i += 10) {
                this.pageLimit.push(i);
            }
            // this.fetchListData();
        },
        watch: {
            limit: function () {
                this.fetchListData();
            }
        },
        computed: {
            getSkipCount() {
                if (this.total == 0) {
                    return 0
                } else {
                    let skip_count = this.skip > this.total ? this.total : this.skip + 1;
                    return skip_count;
                }
            },
        }
    }
</script>
<style scoped>
    

    .btn-shift {
        border: 2px solid #038b62 !important;
        background: white;
        border-radius: 5px;
        color: #038b62;
    }

    .tab-list .list-text {
        font-size: 14px;
        font-weight: 500;
        font-weight: 600;
        color: #000;
    }

    .tab-list .list-text-count {
        font-size: 14px;
        font-weight: 500;
        font-weight: 600;
        color: rgba(54, 54, 54, 0.61);
    }

    .tab-list .list-text.active {
        color: #00448b;
    }

    .tab-list li {
        padding-bottom: 5px;
    }

    .tab-list li.active {
        border-bottom: #00448b solid 2px;
    }
    .no-underline {
        text-decoration: none !important;
    }
</style>